import {Component, Input, OnInit} from '@angular/core';
import {Meeting} from '../../../shared/interface/meeting';
import {MEETING_TYPE_EXAM, MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_ENTRANCE_EXAM} from '../../../shared/services/dict.service';

@Component({
  selector: 'app-meeting-calendar-event',
  templateUrl: './meeting-calendar-event.component.html',
  styleUrls: ['./meeting-calendar-event.component.scss']
})
export class MeetingCalendarEventComponent implements OnInit {
  @Input() meeting: Meeting;

  readonly MEETING_TYPE_IDD_TRAINING = MEETING_TYPE_IDD_TRAINING;
  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_NEW_AGENT_TRAINING = MEETING_TYPE_NEW_AGENT_TRAINING;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;
  tooltipText = '';

  constructor() { }

  ngOnInit(): void {
    if (this.meeting.subject) {
      this.tooltipText = 'Temat: ' + this.meeting.subject;
    }

    if (this.meeting.examType) {
      this.tooltipText = 'Rodzaj egzaminu: ' + this.meeting.examType.name;
    }

    this.tooltipText = this.tooltipText + '\nStatus: ' + this.meeting.status.name;
  }

}
